"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _reactRedux = require("react-redux");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dist = require("@low6dev/react-utils/dist");

var _actions = require("./actions");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.32);\n  margin-bottom: ", ";\n  display: grid;\n  grid-template-columns: 2fr 86px;\n  justify-content: space-between;\n  grid-template-rows: auto auto;\n  gap: 1rem 0.5rem;\n  align-items: center;\n  padding: 1rem 1rem 1rem 1.5rem;\n\n  @media (min-width: ", ") {\n    grid-template-columns: 3fr 1fr;\n  }\n"])), function (p) {
  return p.noBottomMargin ? 0 : "1rem";
}, function (props) {
  return props.theme.screenWidthXs;
});

var StyledUser = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n"])));

var StyledUserName = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  font-size: 1.125rem;\n  color: rgba(255, 255, 255, 0.96);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.5;\n"])));

var StyledUserImage = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 50%;\n  object-fit: contain;\n\n  @media (min-width: ", ") {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n"])), function (props) {
  return props.theme.screenWidthXs;
});

var StyledViewPicksButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 0;\n  white-space: nowrap;\n  height: 1.75rem;\n  font-size: 0.75rem;\n  border-radius: 1.5rem;\n  background: ", ";\n  color: ", ";\n\n  @media (min-width: ", ") {\n    height: 2.5rem;\n  }\n"])), function (p) {
  return p.theme.colorLeaderboardButtonBackground || "white";
}, function (p) {
  return p.theme.colorLeaderboardButtonText || p.theme.colorLeaderboardButtonText;
}, function (props) {
  return props.theme.screenWidthXs;
});

var StyledBottomRow = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  grid-column-end: 3;\n  grid-column-start: 1;\n  display: flex;\n  justify-content: space-between;\n  min-width: 0;\n  margin-bottom: 0.25rem;\n"])));

var StyledStats = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 1.5rem;\n"])));

var StyledRank = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));

var StyledRankLabel = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.66);\n  margin-bottom: 3px;\n"])));

var StyledRankValue = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  color: rgba(255, 255, 255, 0.96);\n  font-size: 1.125rem;\n"])));

var StyledStat = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n"])));

var StyledStatLabel = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.66);\n  margin-bottom: 3px;\n"])));

var StyledStatValue = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: rgba(255, 255, 255, 0.96);\n  font-size: 1.125rem;\n"])));

var StyledPrizeIcon = _styledComponents.default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background: white;\n  border-radius: 0.25rem;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.hasPrize ? p.theme.colorLeaderboardPrizeBackground : (0, _polished.rgba)(p.theme.colorLeaderboardPrizeBackground, 0.12);
}, function (p) {
  return p.hasPrize ? p.theme.colorLeaderboardPrizeText : (0, _polished.rgba)(p.theme.colorLeaderboardPrizeText, 0.12);
});

var StyledTitle = _styledComponents.default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  grid-column-end: 3;\n  grid-column-start: 1;\n  padding-top: 1rem;\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.66);\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n"])));

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      activeBet = _ref.activeBet,
      app = _ref.app,
      hidePrizeMoney = _ref.hidePrizeMoney,
      hasPrizeOverride = _ref.hasPrizeOverride,
      showPrizeIconIfAllQuestionsCorrect = _ref.showPrizeIconIfAllQuestionsCorrect,
      showPrizeIconIfAllButOneQuestionsCorrect = _ref.showPrizeIconIfAllButOneQuestionsCorrect;
  var dispatch = (0, _reactRedux.useDispatch)();
  var language = app.language;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.leaderboard;
  }),
      userName = _useSelector.userName,
      userImage = _useSelector.userImage,
      isShowingMyBet = _useSelector.isShowingMyBet;

  console.log("activeBet", activeBet);

  var handleMyBetClicked = function handleMyBetClicked() {
    window.scrollTo(0, 0);
    dispatch((0, _actions.getMyBet)(activeBet, !isShowingMyBet));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    noBottomMargin: isShowingMyBet,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledUser, {
      children: [!userImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
        isCircle: true,
        skeletonWidth: "2.5rem",
        skeletonHeight: "2.5rem"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledUserImage, {
        src: userImage
      }), !userName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
        skeletonHeight: "20px"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledUserName, {
        children: userName
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledViewPicksButton, {
      onClick: handleMyBetClicked,
      children: isShowingMyBet ? translations.leaderboard : translations.myPicks
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBottomRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledStats, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledStat, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStatLabel, {
            children: translations.rank
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStatValue, {
            children: activeBet !== null && activeBet !== void 0 && activeBet.rank ? (0, _dist.ordinalSuffix)(activeBet === null || activeBet === void 0 ? void 0 : activeBet.rank, "dutch") : "-"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledStat, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStatLabel, {
            children: translations.points
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStatValue, {
            children: (activeBet === null || activeBet === void 0 ? void 0 : activeBet.points) === undefined ? "-" : activeBet === null || activeBet === void 0 ? void 0 : activeBet.points
          })]
        }), !hidePrizeMoney && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledStat, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStatLabel, {
            children: translations.winning
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStatValue, {
            children: !(activeBet !== null && activeBet !== void 0 && activeBet.prize) ? "-" : /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.PenceToPounds, {
              isDutch: app.language === "dutch",
              showCurrencySymbol: true,
              children: activeBet === null || activeBet === void 0 ? void 0 : activeBet.prize
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPrizeIcon, {
        hasPrize: showPrizeIconIfAllQuestionsCorrect || showPrizeIconIfAllButOneQuestionsCorrect ? hasPrizeOverride : activeBet === null || activeBet === void 0 ? void 0 : activeBet.prize,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.MatIcon, {
          children: "star"
        })
      })]
    }), isShowingMyBet && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      children: translations.myPicks
    })]
  });
};

var _default = Wrapper;
exports.default = _default;